import React from 'react';
import { Flex } from '@qga/roo-ui/components';

import Text from '@/components/Text';
import Inclusion from '@/v2/components/ui/PackageInclusions/Inclusion';

export type RoomTypeProps = {
  name: string;
};

const RoomType = ({ name }: RoomTypeProps) => {
  return (
    <Flex flexDirection="column" gap="1">
      <Text
        m="0"
        as="h3"
        color="text.body"
        fontSize={['xs', null, 'sm']}
        lineHeight={['20px', null, '24px']}
      >
        Room Type
      </Text>
      <Inclusion icon="stay" title={name} />
    </Flex>
  );
};

export default RoomType;
